import { EntityApprovalStatus, entityApprovalStatus } from '@/api/entity/types.ts';
import CheckIcon from '@/assets/svg/ui-elements/check-green.svg';
import CheckVerifiedIcon from '@/assets/svg/ui-elements/check-verified-outline.svg';
import RejectIcon from '@/assets/svg/ui-elements/close-circle-outline-red.svg';
import HourglassIcon from '@/assets/svg/ui-elements/hourglass-orange-alt.svg';

import Dots from '../Dots';
import Tooltip from '../Tooltip';
import Typography from '../Typography';
import { entityStatusLabel, ROLE_CONFIG } from './data';
import { RoleButton, RoleInfo, StatusIconBox, TooltipRow } from './UserDropdown.styled';

type Entity = {
  entityId: string;
  entityName: string;
  entityApprovalStatus?: string;
};

type Props = {
  entity: Entity;
  isActive: boolean;
  isLocked: boolean;
  tooltipTitle: string;
  onSelect: (_entityId: string) => void;
};

const StatusIcon = ({ status }: { status?: string }) => {
  if (status === entityApprovalStatus.Verified) return <CheckVerifiedIcon />;
  if (status === entityApprovalStatus.Rejected) return <RejectIcon />;
  return <HourglassIcon />;
};

export const EntityItem = ({ entity, isActive, isLocked, tooltipTitle, onSelect }: Props) => {
  return (
    <Tooltip title={tooltipTitle} side="top" disabled={!isLocked}>
      <TooltipRow>
        <RoleButton aria-pressed={isActive} onClick={() => onSelect(entity.entityId)}>
          <Dots color={ROLE_CONFIG.entity.dot} size="lg" />

          <RoleInfo>
            <Tooltip title={entity.entityName} side="top" disabled={entity.entityName.length < 26}>
              <Typography as="span" variant="body2" noWrap>
                {entity.entityName}
              </Typography>
            </Tooltip>

            <StatusIconBox>
              <Tooltip
                title={
                  entityStatusLabel[
                    (entity.entityApprovalStatus as EntityApprovalStatus) ||
                      entityApprovalStatus.Draft
                  ]
                }
              >
                <div>
                  <StatusIcon status={entity.entityApprovalStatus} />
                </div>
              </Tooltip>
            </StatusIconBox>
          </RoleInfo>

          {isActive && <CheckIcon />}
        </RoleButton>
      </TooltipRow>
    </Tooltip>
  );
};
